import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { FilterGlobalResponseModel } from 'src/app/models/responses/filter-global-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { TransferConstructionSiteDetailTableModel } from 'src/app/models/tables/rental/transfer-construction-site-detail-table.model';
import { TransferConstructionSiteTableModel } from 'src/app/models/tables/rental/transfer-construction-site-table.model';
import { HeaderService } from 'src/app/services/header/header.service';
import { TransferConstructionSiteDetailService } from 'src/app/services/rental/transfer-construction-site-detail.service';
import { TransferConstructionSiteService } from 'src/app/services/rental/transfer-construction-site.service';

@Component({
  selector: 'app-transfer-construction-site',
  templateUrl: './transfer-construction-site.component.html',
  styleUrls: ['./transfer-construction-site.component.scss'],
  standalone: false
})
export class TransferConstructionSiteComponent implements OnInit {

  nameWindow: string = 'Traslados Entre Obras';
  generalHeader: ColumnResponseModel[] = [];
  generalData: PagedResponseModel<TransferConstructionSiteTableModel> = new PagedResponseModel<TransferConstructionSiteTableModel>();
  detailHeader: FilterGlobalResponseModel = new FilterGlobalResponseModel();
  detailData: PagedResponseModel<TransferConstructionSiteDetailTableModel> = new PagedResponseModel<TransferConstructionSiteDetailTableModel>();
  storeConsolidated: boolean = true;
  projectName = ProjectName.projectName;
  activeTabIndex = 0;
  page: number = 1;
  limit: number = 10;
  columnSort: string | null = null;
  ascendant: boolean = true;
  filters: ColumnResponseModel[] = []
  previousSort: { field: string; isAscsendant: number };
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    },
  ];

  constructor(private transferConstructionSiteService: TransferConstructionSiteService,
    private transferConstructionSiteDetailService: TransferConstructionSiteDetailService,
    private router: Router,
    private title: Title,
    private headerService: HeaderService
  ) { }

  async ngOnInit() {
    this.title.setTitle(`${this.nameWindow} -  ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    await Promise.all([
      this.getColumnsForGeneralConsultation(),
      this.getTransferConstructionSiteWithPagination(),
    ]);
  }

  async exportDetailConsultation() {
    try {
      const response = await firstValueFrom(this.transferConstructionSiteDetailService.exportDetailConsultation(this.filters, this.columnSort, this.ascendant));
      const blob = response;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Traslado Entre Obras Detalle.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al exportar los traslado entre obras detalle.', error);
    }
  }

  async exportGeneralConsultation() {
    try {
      const response = await firstValueFrom(this.transferConstructionSiteService.exportGeneralConsultation(this.filters, this.columnSort, this.ascendant));
      const blob = response;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'TrasladoEntreObras.xlsx'; // El nombre del archivo
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al exportar los traslado entre obras.', error);
    }
  }

  async getAllTransferConstructionSiteDetailsWithPagination() {
    try {
      this.detailData = await firstValueFrom(this.transferConstructionSiteDetailService.getAllTransferConstructionSiteDetailsWithPagination(this.page, this.limit, this.columnSort, this.ascendant, this.storeConsolidated, this.filters));
    } catch (error) {
      console.error('Error al buscar los detalles de los traslado entre obras.', error);
    }
  }

  async getColumnsForGeneralConsultation() {
    try {
      if (this.generalHeader.length === 0) {
        this.generalHeader = await firstValueFrom(this.transferConstructionSiteService.getColumnsForGeneralConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }

  async getColumnsForDetailConsultation() {
    try {
      if (this.detailHeader.columns.length === 0) {
        this.detailHeader = await firstValueFrom(this.transferConstructionSiteDetailService.getColumnsForDetailConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }

  async getTransferConstructionSiteWithPagination() {
    try {
      this.generalData = await firstValueFrom(this.transferConstructionSiteService.getTransferConstructionSiteWithPagination(this.page, this.limit, this.columnSort, this.ascendant, this.filters));
    } catch (error) {
      console.error('Error al buscar los traslado entre obras.', error);
    }
  }

  public async handleTabChange(tabIndex: number) {
    this.generalHeader.length = this.generalHeader.length === 1 ? 0 : this.generalHeader.length;
    this.detailHeader.columns.length = this.detailHeader.columns.length === 1 ? 0 : this.detailHeader.columns.length;
    if (this.activeTabIndex === tabIndex) return;

    this.activeTabIndex = tabIndex;

    switch (this.activeTabIndex) {
      case 0:
        await Promise.all([
          this.getColumnsForGeneralConsultation(),
          this.getTransferConstructionSiteWithPagination()
        ]);
        break;
      case 1:
        await Promise.all([
          this.getColumnsForDetailConsultation(),
          this.getAllTransferConstructionSiteDetailsWithPagination()
        ]);

        break;
    }
  }

  newTransferConstructionSite() {
    this.router.navigate(['/transfer-construction-site/register']);
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    switch (this.activeTabIndex) {
      case 0:
        await this.getTransferConstructionSiteWithPagination()
        break;
      case 1:
        await this.getAllTransferConstructionSiteDetailsWithPagination()
        break;
    }
  }

  async onExport() {
    switch (this.activeTabIndex) {
      case 0:
        await this.exportGeneralConsultation();
        break;
      case 1:
        await this.exportDetailConsultation();
        break;
    }
  }

  onAction(event: { action: string, item?: TransferConstructionSiteTableModel }) {
    if (event.action === 'edit' && event.item) {
      this.router.navigate([`/transfer-construction-site/register/${event.item.transferConstructionSiteId}`]);
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    // Procesar cada filtro
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }
}
